/*
    Actions that will cause state mutation in multiple reducers
*/

export const LOGOUT = "xlinkonline/common/LOGOUT";
